const SpriteSVG = () => (
    <div className="app-svg-sprite">
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol
                fill="currentColor"
                viewBox="0 0 18 30"
                id="arrow-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.193 29.07c.637 0 1.277-.244 1.764-.73L16.58 16.773a2.505 2.505 0 000-3.543L4.957 1.656a2.497 2.497 0 00-3.534.007c-.973.98-.97 2.563.007 3.537l9.843 9.8-9.843 9.8a2.5 2.5 0 001.763 4.27z"
                    fill="#fff"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 10 6"
                id="arrow-small-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.22 1.557a.747.747 0 01-.219.53l-3.47 3.486a.751.751 0 01-1.063 0L.996 2.086A.749.749 0 112.06 1.028L5 3.981l2.94-2.953a.75.75 0 011.281.53z"
                    fill="#14151E"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 18 29"
                id="arrow-white-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.193 28.928c.637 0 1.277-.244 1.764-.73L16.58 16.63a2.505 2.505 0 000-3.543L4.957 1.514a2.497 2.497 0 00-3.534.007c-.973.98-.97 2.563.007 3.537l9.843 9.8-9.843 9.8a2.5 2.5 0 001.763 4.27z"
                    fill="#fff"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 17 16"
                id="close-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.623 13.578c.422.469.422 1.172 0 1.594-.469.469-1.172.469-1.594 0L8.498 9.594 2.92 15.172c-.469.469-1.172.469-1.594 0-.469-.422-.469-1.125 0-1.594L6.904 8 1.326 2.422c-.469-.469-.469-1.172 0-1.594a1.027 1.027 0 011.547 0l5.625 5.625L14.076.875a1.026 1.026 0 011.547 0c.469.422.469 1.125 0 1.594L10.045 8l5.578 5.578z"
                    fill="#313131"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 40 41"
                id="customers-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.918 25.091c-5.75 0-10.602.94-10.602 4.566 0 3.628 4.883 4.534 10.602 4.534 5.75 0 10.602-.94 10.602-4.566 0-3.627-4.883-4.534-10.602-4.534z"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    d="M19.918 21.636c3.893 0 7.015-3.14 7.015-7.055 0-3.918-3.122-7.056-7.015-7.056-3.894 0-7.016 3.138-7.016 7.056 0 3.916 3.122 7.055 7.016 7.055zM35.148 16.224c1.007-3.963-1.946-7.522-5.707-7.522-.409 0-.8.045-1.182.122-.05.012-.108.037-.137.082-.035.057-.01.134.028.184a9.679 9.679 0 011.779 5.617 9.604 9.604 0 01-1.64 5.402.264.264 0 00.177.407c.263.047.532.07.806.078 2.739.072 5.197-1.7 5.876-4.37z"
                    fill="#6322D0"
                />
                <path
                    d="M38.016 25.553c-.502-1.075-1.712-1.812-3.552-2.173-.869-.213-3.22-.514-5.405-.473-.033.004-.051.027-.054.042-.005.02.004.057.048.08 1.01.502 4.915 2.689 4.424 7.301-.02.2.14.373.338.343.96-.138 3.434-.673 4.2-2.337a3.204 3.204 0 000-2.783z"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    d="M11.743 8.824a5.857 5.857 0 00-1.182-.121c-3.76 0-6.714 3.559-5.705 7.52.677 2.671 3.135 4.444 5.874 4.372.274-.008.544-.033.806-.078a.264.264 0 00.177-.407 9.607 9.607 0 01-1.64-5.402c0-2.085.65-4.026 1.78-5.618.036-.05.063-.126.027-.183-.03-.047-.085-.07-.137-.083z"
                    fill="#6322D0"
                />
                <path
                    d="M5.537 23.38c-1.84.36-3.049 1.098-3.55 2.172a3.197 3.197 0 000 2.785c.767 1.663 3.24 2.199 4.2 2.335.2.03.358-.14.337-.342-.491-4.61 3.414-6.798 4.426-7.3.042-.025.05-.06.046-.082-.003-.015-.02-.037-.052-.04-2.188-.042-4.537.258-5.407.471z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 40 40"
                id="direct-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="20" cy="20" fill="#6322D0" r="5" />
                <path
                    opacity=".4"
                    d="M26.25 9.93h-12.5a3.808 3.808 0 00-3.82 3.82v12.5a3.808 3.808 0 003.82 3.82h12.5a3.808 3.808 0 003.819-3.82v-12.5a3.808 3.808 0 00-3.82-3.82zM20 24.515A4.505 4.505 0 0115.484 20c0-2.5 2.014-4.514 4.514-4.514 2.5 0 4.514 2.014 4.514 4.514 0 2.5-2.014 4.514-4.514 4.514z"
                    fill="#6322D0"
                />
                <path
                    d="M17.917 8.542c.59 0 1.041-.452 1.041-1.042V4.375c0-.59-.451-1.042-1.041-1.042-.59 0-1.042.452-1.042 1.042V7.5c0 .59.451 1.042 1.042 1.042zM22.08 8.542c.591 0 1.042-.452 1.042-1.042V4.375c0-.59-.451-1.042-1.041-1.042-.59 0-1.042.452-1.042 1.042V7.5c0 .59.451 1.042 1.042 1.042zM13.749 8.542c.59 0 1.041-.452 1.041-1.042V4.375c0-.59-.451-1.042-1.041-1.042-.59 0-1.042.452-1.042 1.042V7.5c0 .59.451 1.042 1.042 1.042zM26.249 8.542c.59 0 1.041-.452 1.041-1.042V4.375c0-.59-.451-1.042-1.041-1.042-.59 0-1.042.452-1.042 1.042V7.5c0 .59.451 1.042 1.042 1.042zM17.917 31.458c-.59 0-1.042.452-1.042 1.042v3.125c0 .59.451 1.042 1.042 1.042.59 0 1.041-.452 1.041-1.042V32.5c0-.59-.451-1.042-1.041-1.042zM22.08 31.458c-.59 0-1.04.452-1.04 1.042v3.125c0 .59.45 1.042 1.04 1.042.591 0 1.042-.452 1.042-1.042V32.5c0-.59-.451-1.042-1.041-1.042zM13.749 31.458c-.59 0-1.042.452-1.042 1.042v3.125c0 .59.451 1.042 1.042 1.042.59 0 1.041-.452 1.041-1.042V32.5c0-.59-.451-1.042-1.041-1.042zM26.249 31.458c-.59 0-1.042.452-1.042 1.042v3.125c0 .59.451 1.042 1.042 1.042.59 0 1.041-.452 1.041-1.042V32.5c0-.59-.451-1.042-1.041-1.042zM35.624 16.875h-3.125c-.59 0-1.042.451-1.042 1.042 0 .59.451 1.041 1.042 1.041h3.125c.59 0 1.041-.451 1.041-1.041 0-.59-.451-1.042-1.041-1.042zM35.624 21.042h-3.125c-.59 0-1.042.451-1.042 1.041 0 .59.451 1.042 1.042 1.042h3.125c.59 0 1.041-.451 1.041-1.042 0-.59-.451-1.041-1.041-1.041zM32.499 14.792h3.125c.59 0 1.041-.452 1.041-1.042 0-.59-.451-1.042-1.041-1.042h-3.125c-.59 0-1.042.452-1.042 1.042 0 .59.451 1.042 1.042 1.042zM35.624 25.208h-3.125c-.59 0-1.042.452-1.042 1.042 0 .59.451 1.042 1.042 1.042h3.125c.59 0 1.041-.452 1.041-1.042 0-.59-.451-1.042-1.041-1.042zM7.499 16.875H4.374c-.59 0-1.042.451-1.042 1.042 0 .59.451 1.041 1.042 1.041h3.125c.59 0 1.041-.451 1.041-1.041 0-.59-.451-1.042-1.041-1.042zM7.499 21.042H4.374c-.59 0-1.042.451-1.042 1.041 0 .59.451 1.042 1.042 1.042h3.125c.59 0 1.041-.451 1.041-1.042 0-.59-.451-1.041-1.041-1.041zM7.499 12.708H4.374c-.59 0-1.042.452-1.042 1.042 0 .59.451 1.042 1.042 1.042h3.125c.59 0 1.041-.452 1.041-1.042 0-.59-.451-1.042-1.041-1.042zM7.499 25.208H4.374c-.59 0-1.042.452-1.042 1.042 0 .59.451 1.042 1.042 1.042h3.125c.59 0 1.041-.452 1.041-1.042 0-.59-.451-1.042-1.041-1.042z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 40 40"
                id="favorite-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity=".4"
                    d="M21.626 5.19l3.71 7.456c.274.54.796.916 1.398 1l8.335 1.213c.486.069.928.325 1.227.717.295.387.421.877.35 1.36-.059.4-.247.77-.535 1.053l-6.04 5.855a1.76 1.76 0 00-.535 1.606l1.487 8.23c.158.994-.5 1.931-1.487 2.12a1.947 1.947 0 01-1.19-.19l-7.435-3.874a1.949 1.949 0 00-1.756 0L11.72 35.61a1.905 1.905 0 01-2.553-.746 1.885 1.885 0 01-.194-1.165l1.487-8.233a1.768 1.768 0 00-.535-1.607l-6.04-5.852a1.807 1.807 0 01-.048-2.554l.048-.048a1.796 1.796 0 011.07-.526l8.336-1.215a1.856 1.856 0 001.397-1l3.577-7.475a1.844 1.844 0 011.695-1.022h.224a1.86 1.86 0 011.442 1.022z"
                    fill="#6322D0"
                />
                <path
                    d="M19.985 31.529c-.322.01-.637.096-.92.251l-7.398 3.865a1.93 1.93 0 01-2.497-.769 1.843 1.843 0 01-.193-1.156l1.478-8.215c.1-.597-.1-1.204-.534-1.624l-6.042-5.85a1.822 1.822 0 010-2.6 1.89 1.89 0 011.053-.53l8.342-1.227a1.805 1.805 0 001.395-1l3.626-7.569a1.842 1.842 0 011.704-.936c-.014.496-.014 27.023-.014 27.36z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 64 64"
                id="location"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.75 7.831a18.372 18.372 0 0118.759.155c5.715 3.552 9.188 9.892 9.156 16.711-.133 6.775-3.858 13.143-8.513 18.066a49.936 49.936 0 01-8.956 7.52 3.133 3.133 0 01-1.087.384 2.187 2.187 0 01-1.042-.317 49.375 49.375 0 01-12.902-12.126 24.744 24.744 0 01-4.833-13.865c-.004-6.833 3.591-13.142 9.418-16.528zm3.366 19.355c.98 2.416 3.294 3.992 5.86 3.992a6.238 6.238 0 004.489-1.87 6.475 6.475 0 001.852-4.566c.009-2.614-1.53-4.976-3.899-5.983a6.256 6.256 0 00-6.917 1.386 6.546 6.546 0 00-1.385 7.041z"
                    fill="#6322D0"
                />
                <ellipse
                    opacity=".4"
                    cx="31.997"
                    cy="56"
                    rx="13.333"
                    ry="2.667"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 54 48"
                id="mail"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity=".4"
                    d="M53.665 34.507c0 7.44-5.973 13.467-13.413 13.494H13.799C6.385 48 .332 42 .332 34.56v-.027S.348 22.73.369 16.795c.003-1.115 1.283-1.739 2.155-1.045 6.336 5.026 17.667 14.192 17.808 14.312a10.847 10.847 0 006.747 2.373c2.453 0 4.853-.856 6.746-2.403.142-.093 11.219-8.983 17.651-14.093.875-.696 2.16-.072 2.163 1.04.026 5.89.026 17.528.026 17.528z"
                    fill="#6322D0"
                />
                <path
                    d="M52.266 7.13A13.427 13.427 0 0040.41-.001H13.797a13.427 13.427 0 00-11.856 7.13 2.303 2.303 0 00.59 2.875l19.8 15.838a7.537 7.537 0 004.746 1.677h.053c1.68 0 3.36-.557 4.747-1.677l19.8-15.838a2.303 2.303 0 00.59-2.874z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 26 21"
                id="menu-bar"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    y=".132"
                    width="26"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    y="8.132"
                    width="26"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
                <rect
                    y="16.132"
                    width="26"
                    height="4"
                    rx="2"
                    fill="currentColor"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 50 51"
                id="messenger-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.753 10.228c0 4.627 3.757 8.378 8.39 8.378a8.406 8.406 0 001.521-.146v16.61c0 6.987-4.122 11.121-11.12 11.121H15.302c-7.016 0-11.138-4.134-11.138-11.122V19.85c0-6.987 4.122-11.158 11.138-11.158H31.9a7.965 7.965 0 00-.147 1.537zm-4.361 21.165l5.954-7.683v-.037c.51-.685.38-1.65-.294-2.177a1.522 1.522 0 00-2.161.311l-5.02 6.458-5.716-4.5a1.54 1.54 0 00-2.18.292l-6.155 7.94c-.216.269-.333.605-.33.95a1.54 1.54 0 002.84.896l5.148-6.658 5.715 4.482a1.54 1.54 0 002.199-.274z"
                    fill="#6322D0"
                />
                <circle
                    opacity=".4"
                    cx="40.622"
                    cy="9.733"
                    r="5.208"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 52 52"
                id="phone"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.753 27.26c10.637 10.634 13.05-1.669 19.823 5.1 6.53 6.527 10.283 7.835 2.01 16.106-1.036.833-7.62 10.852-30.76-12.28C-7.313 13.05 2.7 6.46 3.533 5.424 11.825-2.87 13.11.905 19.64 7.433c6.773 6.771-5.525 9.192 5.113 19.827z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 20 21"
                id="search-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <ellipse
                    cx="8.599"
                    cy="9.511"
                    rx="8.599"
                    ry="8.653"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    d="M18.677 20.813a1.32 1.32 0 01-.89-.384l-2.036-2.38a1.087 1.087 0 01-.08-1.522.975.975 0 011.387 0l2.561 2.05c.369.377.483.937.29 1.43a1.335 1.335 0 01-1.18.851l-.052-.045z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 20 20"
                id="send-icon"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.427.578c-.5-.51-1.24-.7-1.93-.5l-16.09 4.65a1.914 1.914 0 00-1.383 1.51c-.142.746.354 1.694 1.002 2.09L6.057 11.4a1.308 1.308 0 001.61-.19l5.76-5.762a.735.735 0 011.06 0c.29.29.29.76 0 1.06l-5.77 5.761a1.31 1.31 0 00-.194 1.61l3.074 5.05c.36.598.98.94 1.66.94.08 0 .17 0 .25-.012.78-.099 1.4-.63 1.63-1.38l4.77-15.969c.21-.68.02-1.42-.48-1.93z"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.011 14.808a.749.749 0 01-.53-1.28l1.365-1.366a.752.752 0 011.061 0 .752.752 0 010 1.06l-1.366 1.366a.744.744 0 01-.53.22zM4.773 16a.749.749 0 01-.53-1.28l1.365-1.366a.752.752 0 011.06 0 .752.752 0 010 1.061L5.304 15.78a.744.744 0 01-.53.22zm.253 3.568c.146.147.338.22.53.22a.744.744 0 00.53-.22l1.366-1.365a.752.752 0 000-1.06.752.752 0 00-1.06 0l-1.366 1.365a.749.749 0 000 1.06z"
                    fill="#6322D0"
                />
            </symbol>
            <symbol
                fill="currentColor"
                viewBox="0 0 40 40"
                id="user"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.918 24.233c-5.75 0-10.602.94-10.602 4.566 0 3.628 4.883 4.534 10.602 4.534 5.75 0 10.602-.94 10.602-4.566 0-3.627-4.883-4.534-10.602-4.534z"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    d="M19.918 20.778c3.893 0 7.015-3.14 7.015-7.055 0-3.918-3.122-7.056-7.015-7.056-3.894 0-7.016 3.138-7.016 7.056 0 3.915 3.122 7.055 7.016 7.055zM35.148 15.365c1.007-3.962-1.946-7.52-5.707-7.52-.409 0-.8.044-1.182.12-.05.013-.108.038-.137.083-.035.057-.01.134.028.184a9.679 9.679 0 011.779 5.618 9.604 9.604 0 01-1.64 5.401.264.264 0 00.177.407c.263.047.532.07.806.078 2.739.072 5.197-1.7 5.876-4.37z"
                    fill="#6322D0"
                />
                <path
                    d="M38.016 24.695c-.502-1.075-1.712-1.812-3.552-2.174-.869-.213-3.22-.513-5.405-.472-.033.004-.051.027-.054.042-.005.02.004.057.048.08 1.01.502 4.915 2.689 4.424 7.301-.02.2.14.373.338.342.96-.137 3.434-.672 4.2-2.336a3.204 3.204 0 000-2.783z"
                    fill="#6322D0"
                />
                <path
                    opacity=".4"
                    d="M11.743 7.966a5.857 5.857 0 00-1.182-.121c-3.76 0-6.714 3.558-5.705 7.52.677 2.671 3.135 4.444 5.874 4.372.274-.008.544-.034.806-.078a.264.264 0 00.177-.407 9.608 9.608 0 01-1.64-5.402c0-2.085.65-4.026 1.78-5.618.036-.05.063-.126.027-.183-.03-.047-.085-.07-.137-.083z"
                    fill="#6322D0"
                />
                <path
                    d="M5.537 22.521c-1.84.362-3.049 1.099-3.55 2.173a3.197 3.197 0 000 2.785c.767 1.663 3.24 2.198 4.2 2.335.2.03.358-.141.337-.342-.491-4.611 3.414-6.798 4.426-7.3.042-.025.05-.06.046-.082-.003-.015-.02-.037-.052-.04-2.188-.042-4.537.258-5.407.471z"
                    fill="#6322D0"
                />
            </symbol>
        </svg>
    </div>
);
export default SpriteSVG;
